import React from 'react';
import { useSurveyStore } from '../../surveyutilities/surveyStore';

function BlockControls({ block, isFirst, isLast }) {
    const moveQuestion = useSurveyStore((state) => state.moveQuestion);
    const removeQuestion = useSurveyStore((state) => state.removeQuestion);

    return (
        <div className="ecx-survey-block__controls">
            <button
                type="button"
                className="ecx-survey-block__ctrl"
                title="Move up"
                disabled={isFirst}
                onClick={(event) => {
                    event.stopPropagation();
                    moveQuestion(block.internalId, 'up');
                }}
            >
                <i className="bi bi-chevron-up" />
            </button>
            <button
                type="button"
                className="ecx-survey-block__ctrl"
                title="Move down"
                disabled={isLast}
                onClick={(event) => {
                    event.stopPropagation();
                    moveQuestion(block.internalId, 'down');
                }}
            >
                <i className="bi bi-chevron-down" />
            </button>
            <button
                type="button"
                className="ecx-survey-block__ctrl is-danger"
                title="Delete"
                onClick={(event) => {
                    event.stopPropagation();
                    removeQuestion(block.internalId);
                }}
            >
                <i className="bi bi-trash" />
            </button>
        </div>
    );
}

export default BlockControls;
